/* RESPONSIBLE TEAM: team-proactive-support */
import Route from '@ember/routing/route';

export default class AppsAppOutboundSurveyRoute extends Route {}
